import React from 'react';
import '../style/about.css';
import { Container, Row, Col } from 'react-bootstrap';
import aboutbanner from '../assets/aboutbanner.png';
import aboutaside from '../assets/aboutaside.png';

const AboutUs = () => {
  return (
    <div>
    <section className="about-us-container" >
     <Container>
        <Row>
            <Col md={12}>
               <h1>ABOUT US</h1>
               <img src={aboutbanner} />
               <p>At Local Roots, we believe the most meaningful things in life aren’t mass-produced—they’re crafted with care, intention, and a personal touch. They come from the hands of passionate artisans, family farmers, and small business owners who pour their hearts into every product. That belief is at the core of everything we do. We built Local Roots as a digital marketplace designed to celebrate and support these makers, giving them a space to thrive and connect with customers who value authenticity and quality. Here, you’ll find more than just goods—you’ll find stories. From crisp, locally grown produce and everyday pantry staples to small-batch sauces, hand-poured candles, natural skincare, home goods, and so much more, every item on Local Roots is thoughtfully made or harvested by someone in your community who genuinely cares about their craft. We carefully curate each listing to ensure that it reflects our commitment to sustainability, transparency, and a more human way of doing business.</p>
            </Col>
        </Row>
     </Container>
    </section>

    <section className='moreaboutus'>
        <Container>
            <Row>
                <Col md={6}>
                <h2>More About Us</h2>
                <p>We understand that today’s shoppers are looking for more than convenience—they want connection, intention, and impact. That’s why we’ve made it our goal to make shopping local not only easier, but also more rewarding. Behind every item on Local Roots is a person, a family, or a dream. When you support these businesses, you’re helping them grow, create jobs, invest in their future, and continue doing what they love. It’s a ripple effect that strengthens neighborhoods, fosters pride, and builds relationships that last.</p>
                <p>At the core of everything we do are our values: community over competition, sustainability, transparency, inclusion, and intentional living. We believe these aren’t just good business principles—they’re essential to building a better, more human way of living and working together. Our platform is open to all, and we actively seek to amplify underrepresented voices and support diverse creators who bring fresh perspectives and rich traditions to the table. Whether you’re a small business owner ready to share your products with the world, or a shopper searching for goods with soul, Local Roots is your home. Join us in reimagining what it means to shop local. Explore our marketplace, meet the makers, and become part of a growing community that believes the future is handmade, homegrown, and heart-led.</p>
                <ul>
                  <li><a href="/Product">Start Selling</a></li>
                  <li><a href="/AboutUs">Lean More</a></li>
               </ul>
                </Col>
                <Col md={6}>
                <img src={aboutaside}/>
                </Col>
            </Row>
        </Container>
    </section>
    </div>
  );
};


export default AboutUs;
